import React from 'react';

const NicotineForm = React.lazy(() => import('../../../../components/form/standard-forms/nicotine-form'));

export const NicotineFormRoute = () => {
  return <NicotineForm />;
};
